import * as React from 'react';
import { AdvanceTable, IBasicTableColumn, IBasicTableProps } from 'ui-lib';
import { IDeviceTableProps } from './components';
import devicesCss from './devices.css';
import { TableUtils } from '../../../components/table-utils';
import { useDeviceStore } from 'store';
import { InstalledComponentDto } from 'dto/raptor-device.dto';
import { useLoadingStates } from 'hooks/use-loading.hook';
import { MessagesAlert } from 'pages/private/components/alert/messages-alert';

export const RaptorComponentsTable = (props: IDeviceTableProps) => {
    const loadingStates = useLoadingStates();
    const devicesStore = useDeviceStore();
    const [installedComponents, setInstalledComponents] = React.useState<InstalledComponentDto[]>([]);

    const loadInstalledComponents = async () => {
        return loadingStates.withLoading(async () => {
            const result = await devicesStore.getInstalledComponents(props.accountId, props.uid);
            setInstalledComponents(result);
        });
    };

    React.useEffect(() => {
        loadInstalledComponents();
    }, []);

    const columns: IBasicTableColumn[] = [
        TableUtils.createBasicFilterColumn({
            key: 'displayName',
            title: 'Component Name',
        }),
        TableUtils.createBasicFilterColumn({
            key: 'version',
            title: 'Component Version',
        }),
        TableUtils.createBasicFilterColumn({
            key: 'lifecycleState',
            title: 'Lifecycle State',
        }),
        TableUtils.createBasicFilterTimeColumn({
            key: 'lastStatusChangeTimestamp',
            title: 'Last Status Change',
        }),
        TableUtils.createBasicFilterTimeColumn({
            key: 'lastReportedTimestamp',
            title: 'Last Reported Time',
        }),
    ];

    const table: IBasicTableProps = { rowKey: 'name', columns, dataSource: installedComponents };

    return (
        <div className={devicesCss.tabPane}>
            <MessagesAlert errorMessages={loadingStates.errorMessages} />
            <AdvanceTable
                title=''
                table={table}
                loadingState={loadingStates.loading}
                toolbar={{
                    onReload: () => loadInstalledComponents(),
                }}
            />
        </div>
    );
};
